// Копирайт уведомлений бота — spec/08_copy.md, раздел «Уведомления бота».
// Голос — вариант A «своя в чате» (docs/copy-variants.md). Пуш про лучик и маячок — нет:
// первый про тёплый жест, второй тревожный.
//
// Пол: в пушах о близком склоняем по полу этого близкого, в `beacon_self` — по полу того,
// кому пуш адресован. Пол не указан — нейтральная формулировка, не женский род.
// Те же строки собирает бэкенд (jobs/handlers/beaconCheck.ts, modules/ray/ray.service.ts) —
// правки обязаны идти парой.
import { textByGender } from '@lunya/contracts'

import type { PushCopy } from './types'

export const push: PushCopy = {
  // Утренний пуш подписан разделом: в чат приходит текст предсказания, и без подписи непонятно,
  // что именно про него завтра спросят «сбылось?». Ту же строку собирает
  // jobs/handlers/forecastDaily.ts — правки идут парой.
  forecast_daily: ({ text }) => `Предсказание дня 🐾\n\n${text}`,
  link_created: ({ name }) => `Вы с ${name} теперь рядышком!`,
  /**
   * Лучик и комплимент. Ни имени, ни текста: интригу человек разворачивает в приложении
   * (решение основателя). Побочно это снимает вопрос с рода — раньше строка склонялась по
   * полу отправителя, и стоило его не знать, выходило «Дима послала тебе лучик».
   */
  ray: 'Тебе прислали лучик! Посмотри, кто это!',
  compliment: 'Тебе прислали комплимент! Посмотри, кто это!',
  quiet_signal: ({ name }) => `Тс. Загляни сегодня к ${name} 🐾`,
  beacon: ({ name, gender }) =>
    textByGender(
      gender,
      `${name} перестал{|а} отмечаться. Спроси у {него|неё}, точно ли всё хорошо?`,
      `${name} не отмечается несколько дней. Спроси, точно ли всё хорошо?`,
    ),
  beacon_parent: ({ name, gender }) =>
    textByGender(
      gender,
      `${name} давно не заглядывал{|а}. Наберёшь {ему|ей}?`,
      `${name} давно не заглядывает. Наберёшь?`,
    ),
  beacon_self: ({ gender }) =>
    textByGender(
      gender,
      'Ты давно не показывал{ся|ась}. Твои начнут волноваться — загляни на минутку 🐾',
      'Тебя давно не видно. Твои начнут волноваться — загляни на минутку 🐾',
    ),
  vacation_weekly: 'Отдыхай. Я тут. 🐾',
}
